





















































































































import { Component, Vue, Watch, Provide, Prop } from "vue-property-decorator";
import { nxExtenManageClient } from "@/api/nxExtenManageClient";
import {
  UserAssignedListReq,
  AssignExtenPhoneReq
} from "@/pbjs/xcommon/nxExtenManage_pb";
import { setCommon, errorMsg, setPage } from "@/utils/request";
const roleList = () => import("@/components/roleList/index.vue");
import { pagnition } from "@/utils/commonConfig";
@Component({
  name: "AssignPhone",
  components: {
    roleList
  }
})
export default class AssignPhone extends Vue {
  @Prop() Supplier!: any;
  @Prop() ExtNumber!: any;
  @Prop() isAddNewPhone!: any;
  @Provide() private nationValue: string = "";
  @Provide() private token: string | null = "";
  @Provide() private tableRadio: any = "";
  @Provide() private resultData: any = [];
  @Provide() private MorkResultData: any = [
    {
      name: "sss",
      email: "ssss",
      id: 1111
    },
    {
      name: "sss",
      email: "ssss",
      id: 1111
    },
    {
      name: "sss",
      email: "ssss",
      id: 1111
    },
    {
      name: "sss",
      email: "ssss",
      id: 1111
    },
    {
      name: "sss",
      email: "ssss",
      id: 1111
    },
    {
      name: "sss",
      email: "ssss",
      id: 1111
    },
    {
      name: "sss",
      email: "ssss",
      id: 1111
    },
    {
      name: "sss",
      email: "ssss",
      id: 1111
    },
    {
      name: "sss",
      email: "ssss",
      id: 1111
    },
    {
      name: "sss",
      email: "ssss",
      id: 1111
    },
    {
      name: "sss",
      email: "ssss",
      id: 1111
    },
    {
      name: "sss",
      email: "ssss",
      id: 1111
    },
    {
      name: "sss",
      email: "ssss",
      id: 1111
    },
    {
      name: "sss",
      email: "ssss",
      id: 1111
    },
    {
      name: "sss",
      email: "ssss",
      id: 1111
    },
    {
      name: "sss",
      email: "ssss",
      id: 1111
    },
    {
      name: "sss",
      email: "ssss",
      id: 1111
    },
    {
      name: "sss",
      email: "ssss",
      id: 1111
    },
    {
      name: "sss",
      email: "ssss",
      id: 1111
    },
    {
      name: "sss",
      email: "ssss",
      id: 1111
    },
    {
      name: "sss",
      email: "ssss",
      id: 1111
    },
    {
      name: "sss",
      email: "ssss",
      id: 1111
    },
    {
      name: "sss",
      email: "ssss",
      id: 1111
    },
    {
      name: "sss",
      email: "ssss",
      id: 1111
    },
    {
      name: "sss",
      email: "ssss",
      id: 1111
    }
  ];
  @Provide() private isMorked: boolean = false;
  @Provide() private userid: any = "";
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  // @Provide() private roleValue: string = "";
  @Provide() private multipleSelection: any = [];
  // @Provide() private roleOptions: any = [];
  @Provide() private rules: any = {
    phoneStart: [
      { required: true, message: "请输入", trigger: "blur" },
      { min: 1, max: 29, message: "长度小于30个字符", trigger: "blur" }
    ],
    phoneEnd: [{ required: true, message: "请输入", trigger: "blur" }],
    nxtele: [{ required: true, message: "请选择活动资源", trigger: "change" }],
    nxname: [{ required: true, message: "请选择活动资源", trigger: "change" }]
  };
  @Provide() private assignPhoneForm: any = {
    UserName: "",
    Email: ""
  };
    @Provide() private pagnition: any = pagnition;

  get roleData(): any {
    return this.$store.getters.ROLE_INFO;
  }

  private created() {
    this.token = localStorage.getItem("token");
    this.userid = localStorage.getItem("userid");

    // this.getList();
  }
  private mounted(): void {}

  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getList();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getList();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getList();
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getList();
  }

  //  lee 多選框
  private handleSelectionChange(val: any) {
    this.tableRadio = val;
  }
  //  lee 获取列表数据
  private getList() {
    let request: any = new UserAssignedListReq();
    request.setCommonin(setCommon());
    request.setPagein(setPage(this.pageIndex, this.pageSize));
    if (this.assignPhoneForm.UserName) {
      request.setUsername(this.assignPhoneForm.UserName);
    } // lee 用户名
    if (this.assignPhoneForm.Email) {
      request.setEmail(this.assignPhoneForm.Email);
    } // lee 邮箱
    if (this.roleData.name) {
      request.setUsergroup(this.roleData.name);
    } // lee 角色 vuex中获取
    if (this.Supplier) {
      request.setSupplier(Number(this.Supplier));
    } // lee 供应商 vuex中获取
    nxExtenManageClient.userAssignedList(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          if(data.commonout){
            if (data.commonout.code == 0) {
              let _result =
                      typeof data.userassignedlistList == "object"
                              ? data.userassignedlistList
                              : JSON.parse(data.userassignedlistList);
              if (_result) {
                this.resultData = _result;
                this.pagerCount = data.pageout && data.pageout.total;
              }
              // lee 接口数据通了，但是没有数据，暂时Mork一份
              this.resultData = this.isMorked ? this.MorkResultData : _result;
            } else {
              this.$message.error(data.commonout.errmsg);
            }

          }else{
            if (data.code == 0) {
              let _result =
                      typeof data.userassignedlistList == "object"
                              ? data.userassignedlistList
                              : JSON.parse(data.userassignedlistList);
              if (_result) {
                this.resultData = _result;
              }
              // lee 接口数据通了，但是没有数据，暂时Mork一份
              this.resultData = this.isMorked ? this.MorkResultData : _result;
              this.pagerCount = data.pageout && data.pageout.total;
            } else {
              this.$message.error(data.errmsg);
            }            
          }
        }
        if (err) {
       errorMsg(err);
      }
      }
    );
  }
  // lee 搜索操作的判断
  private testSearchForm() {
    let _bool = false;
    for (let i in this.assignPhoneForm) {
      if (this.assignPhoneForm["" + i + ""]) {
        _bool = true;
        return _bool;
      }
    }
  }
  //  lee 筛选操作
  private doSearch() {
    if (this.testSearchForm() || this.roleData.id) {
      this.pageIndex = 1;
      this.getList();
    } else {
      this.$message.warning("Pls enter the right params!!");
    }
  }
  //  Lee 重置表单
  private resetForm(formName: string) {
    (this.$refs[formName] as any).resetFields();
    this.closeAddDialog();
  }
  //  lee 提交操作

  private assignExtenPhone() {}
  private submitForm(formName: string) {
    if (this.tableRadio) {
      let request: any = new AssignExtenPhoneReq();
      request.setCommonin(setCommon());
      request.setExtnumber(Number(this.ExtNumber));
      // 分機管理列表的分機號碼
      request.setAssignid(this.tableRadio.id); // id
      request.setOpuid(this.userid); // 操作人的userId
      nxExtenManageClient.assignExtenPhone(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            let data: any = response.toObject();
            if (!data.commonout || (data.commonout.code == 0)) {
              this.$message.success("successfully！");
              this.$emit("hideAssignPhoneDialog", false);
            } else {
              this.$message.error(data.commonout.errmsg);
            }
          }
          if (err) {
       errorMsg(err);
      }
        }
      );
    } else {
      this.$message.warning("Pls enter the right params!!");
    }
  }
  //  lee  关闭弹窗
  private closeAddDialog() {
    this.$emit("hideAssignPhoneDialog", false);
  }
  //判断是否分配
  private isAssign(source: boolean) {
    let res :any= "";
    if (source) {
      res = "<span style='color: red'>"+this.$t('Dialer.assigned')+"</span>";
    } else {
      res = "<span style='color: blue'>"+this.$t('Dialer.unassigned')+"</span>";
    }
    return res
  }
}
